'use client'

import { Tooltip } from '@graftcode/design-system'

import type { Props } from './AlphaLabel.types'

import styles from './AlphaLabel.module.scss'

const tooltipContent = (
  <div className={styles.tooltipContent}>
    <span>Graftcode is currently in early </span>
    <span>development. Some features may </span>
    <span>
      change or be unstable.{' '}
      <a
        className={styles.learnMoreLink}
        href="https://academy.graftcode.com/documentation?section=docs%2Fhow-graftcode-works%2Falpha-limitations-and-known-constraints.md"
        target="_blank"
        rel="noopener noreferrer"
      >
        LEARN MORE
      </a>
    </span>
  </div>
)

export function AlphaLabel({ withTooltip = true }: Props) {
  if (!withTooltip) {
    return <span className={styles.label}>ALPHA</span>
  }

  return (
    <Tooltip content={tooltipContent} placement="bottom" showArrow>
      <div>
        <span className={styles.label}>ALPHA</span>
      </div>
    </Tooltip>
  )
}
